import { ChoreLength, ChorePriority } from '@chore-project/shared';

/**
 * Shared presentation metadata for chore priority and length. Colours are theme
 * tokens (see index.css) so they adapt to light/dark — previously these were
 * hard-coded hexes duplicated across three pages and illegible in dark mode.
 */
export const PRIORITY_META: Record<ChorePriority, { icon: string; color: string; label: string }> = {
  [ChorePriority.MUST_DO]:   { icon: 'warning',                            color: 'var(--priority-must)',   label: 'Must' },
  [ChorePriority.SHOULD_DO]: { icon: 'flag',                               color: 'var(--priority-should)', label: 'Should' },
  [ChorePriority.CAN_DO]:    { icon: 'ellipsis-horizontal-circle-outline', color: 'var(--priority-can)',    label: 'Can' },
};

export const LENGTH_META: Record<ChoreLength, { label: string }> = {
  [ChoreLength.SHORT]:  { label: '5–10 min' },
  [ChoreLength.MEDIUM]: { label: '15–30 min' },
  [ChoreLength.LONG]:   { label: '45+ min' },
};

/** Colour for the length caption — one readable token in both themes. */
export const LENGTH_COLOR = 'var(--text-muted)';

/** Friendly labels instead of raw enum values in badges. */
export const STATUS_LABEL: Record<string, string> = {
  PENDING: 'To do',
  COMPLETED: 'Done',
  MISSED: 'Skipped',
  SHARED: 'Passed on',
};

export const RECURRENCE_LABEL: Record<string, string> = {
  NONE: 'One-off',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};
